export const achievementData = {
    bio : "Completion of a developer course with distinction, mastering advanced programming concepts, software development methodologies, and cutting-edge technologies. Developed a diverse range of applications, demonstrating expertise in full-stack development, problem-solving, and collaboration. Recognized for delivering high-quality, efficient, and innovative solutions, contributing to successful project outcomes.",
    achievements : [
        {
            id : 1,
            title : 'Masai Full Stack Development Course',
            details : `"2160 Hours" of practical learning (Hard Coding)  
            Also along with it the other trainings like #communication , #planning, #teamwork, #pairprogramming and so many that can't even remember are a plus too.`,
            date : 'Aug 20, 2019',
            field : 'Development',
            image : 'https://media.licdn.com/dms/image/C4D22AQHCOtNQPPy35A/feedshare-shrink_800/0/1676394829897?e=1689206400&v=beta&t=pagODMim_he0MMel-6deUiTw2h9e8L8S6QT18FXftPk'
        },
        {
            id : 2,
            title : 'The Fundamentals Of Digital Marketing From Google',
            details : 'Analytics and insights,Business Strategy, Content, Display advertising, E-commerce,SEM, SEO, Social Media, Web Optimization,',
            date : 'March 20, 2020',
            field : 'Digital Marketing',
            image : 'https://lh3.googleusercontent.com/JwZ74w1xLAO0n24knlxgL9HZJo3NTN3V44YrtyXZvivX4sHYmiyBs89KIxTOIYTR4IDgFq-VFx6L3gutEpDkpicLzl96KKSYbVh3f08'
        },
        // {
        //     id : 3,
        //     title : 'Professional Data Engineer Certification',
        //     details : 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
        //     date : 'Aug 20, 2019',
        //     field : 'Automation',
        //     image : 'https://images.unsplash.com/photo-1489389944381-3471b5b30f04?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80'
        // }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/